import { Onboarding } from "../layout";
import PageLayout from "./PageLayout";

const OnboardingPage = () => {
  return (
    <PageLayout sx={{ width: { xs: "92%", sm: "90%", md: "85%", lg: "85%" },}}>
      <Onboarding />
    </PageLayout>
  );
};

export default OnboardingPage;
